export * from './src/ecom-v1-shippo-configuration-shippo-configurations.meta.js';
